import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

export const getCurrentVersion = () => DS_VERSIONS.default
